import { useContext } from 'react';
import { UserContext } from 'contexts/UserContext';
import { AgreementType } from 'api/types';

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  const { userResult, setUserResult } = context;
  const selectedAgreement = userResult?.selectedAgreement;
  const setSelectedAgreement = (agreement?: AgreementType) =>
    setUserResult({
      user: userResult ? userResult.user : null,
      impersonator: userResult?.impersonator,
      error: userResult?.error ? userResult.error : '',
      loading: userResult?.loading,
      selectedAgreement: agreement,
    });

  return {
    selectedAgreement,
    setSelectedAgreement,
    ...context,
  };
};

export default useUser;
